(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name commons.directive:combineScrolls
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="commons">
       <file name="index.html">
        <scroll-sync>
            <div scroll-sync-dir="verticle"></div>
            <div scroll-sync-dir="verticle"></div>
        </scroll-sync>
       </file>
     </example>
     scroll-sync-dir="" can be verticle, horizontal and both
   *
   */
  angular
    .module('commons')
    .directive('scrollSync', scrollSync);

  function scrollSync($timeout) {
      return {
          restrict: 'AE',
          replace: false,
          controller: function($scope, $element){
              var element = $element;
              $timeout(function(){
                  var hOnly = element.find('[scroll-sync-dir="horizontal"]');
                  var vOnly = element.find('[scroll-sync-dir="verticle"]');
                  var both = element.find('[scroll-sync-dir="both"]');

                  vOnly.on('scroll',_.debounce(function(event) {
                      both.each(function (index) {
                          if( this !== event.currentTarget ){
                              this.scrollTop = event.currentTarget.scrollTop;
                          }
                      });
                  }, 200));

                  hOnly.on('scroll', function (event) {
                      both.each(function (index) {
                          if( this !== event.currentTarget ){
                              this.scrollLeft = event.currentTarget.scrollLeft;
                          }
                      });
                      hOnly.each(function (index) {
                          if( this !== event.currentTarget ){
                              this.scrollLeft = event.currentTarget.scrollLeft;
                          }
                      });
                  });

                  both.on('scroll', function (event) {
                      hOnly.each(function (index) {
                          if( this !== event.currentTarget ){
                              this.scrollLeft = event.currentTarget.scrollLeft;
                          }
                      });
                      vOnly.each(function (index) {
                          if( this !== event.currentTarget ){
                              this.scrollTop = event.currentTarget.scrollTop;
                          }
                      });
                      both.each(function (index) {
                          if( this !== event.currentTarget ){
                              this.scrollTop = event.currentTarget.scrollTop;
                              this.scrollLeft = event.currentTarget.scrollLeft;
                          }
                      })
                  });
              },1000);
          }
      };
  }
}());
